<template>
  <el-drawer class="dialog-box" title="出库单详情" :visible.sync="showFlag" size="80%">
    <div style="padding: 20px;">
      <!-- <div class="pageTitleWrap">
      <vs-breadcrumb class="marLeft12" separator="/">
        <li class="active" @click="back" style="cursor: pointer">
          出库单<span class="vs-breadcrum--separator">/</span>
        </li>
        <li aria-current="page" class="active">订单详情</li>
      </vs-breadcrumb>
    </div> -->
      <div class="deli-head">
        <el-row class="" :gutter="20">
          <el-col :span="7" class="colTitle">客户名称：{{ deliveryDetail.buyer }}</el-col>
          <el-col :span="7" class="colTitle">出库单号：{{ deliveryDetail.billNo }}</el-col>
          <el-col :span="7" class="colTitle">出库日期：{{ deliveryDetail.orcDate }}</el-col>
        </el-row>
        <el-row class="marTop10" :gutter="20">
          <el-col :span="7" class="colTitle">仓库：{{ deliveryDetail.wsName }}</el-col>
          <!-- <el-col :span="7" class="colTitle">物流公司：{{ deliveryDetail.logisticsCompany }}</el-col> -->
          <el-col :span="7" class="colTitle">物流单号：{{ deliveryDetail.transitNo }}</el-col>
          <el-col :span="7" class="colTitle">签回单：{{ deliveryDetail.isPod === true?'是':(deliveryDetail.isPod === false?'否':'--') }}</el-col>
        </el-row>
      </div>
      <el-table :data="deliveryList" border style="margin: 10px 0px; border-bottom: 1px solid #ebeef5;">
        <el-table-column align="center" label="序号" type="index" width="50"></el-table-column>
        <el-table-column align="center" prop="skuCode" label="商品编号" width=""></el-table-column>
        <el-table-column align="center" prop="barCode" label="69码" width=""></el-table-column>
        <el-table-column align="center" prop="skuName" label="商品名称" width="150"></el-table-column>
        <el-table-column align="center" prop="boxUnit" label="规格" width="50"></el-table-column>
        <el-table-column align="center" prop="amount" label="数量" width=""></el-table-column>
        <el-table-column align="center" prop="availableAmount" label="实际库存" width=""></el-table-column>
        <el-table-column align="center" prop="actualQty" label="出库数量" width=""></el-table-column>
        <el-table-column align="center" prop="unitPrice" label="单价（元）" width=""></el-table-column>
        <el-table-column align="center" prop="price" label="金额（元）" width=""></el-table-column>
        <el-table-column align="center" prop="actualUnitPrice" label="实际单价" width=""></el-table-column>
        <el-table-column align="center" prop="actuallyPaid" label="实际金额" width=""></el-table-column>
      </el-table>
      <gc-vs-pagination :pager="page" v-if="pageshow" totalName="totalCount" pageNoName="pagerNo"
        pageSizeName="pageSize" @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange">
      </gc-vs-pagination>


    </div>
  </el-drawer>
</template>

<script>
  import { OrderApi } from "@/modules/server-api/commodity-sys/order";
  import { downloadFileTemplate, downloadExcel } from "@/utils/downloadExcel.js";

  import VsTable from "../vsTable/vsTable";

  export default {
    components: {
      VsTable,

    },
    data() {
      return {
        showFlag: false, //出库单详情
        deliveryDetail: {},
        deliveryList: [],
        pageshow: true,
        page: {
          // 分页
          pageNo: 1,
          pageSize: 20,
          totalCount: 0,
        },
        totalCount: Number,
        pagerNo: Number,
        pageSize: Number,
        billNo: '',
      };
    },
    mounted() {
      // let that = this;
      // that.$vs.loading();
      // that.billNo = sessionStorage.getItem("billNo");
      // that.getGoodsInfo();
      // that.getGoodsList();
    },
    methods: {
      getData() {
        let that = this;
        that.$vs.loading();
        that.billNo = sessionStorage.getItem("billNo");
        that.getGoodsInfo();
        that.getGoodsList();
        this.showFlag = true
      },
      // 面包屑返回
      back() {
        this.$router.push({ path: "/modules/order/delivery" }).catch(() => { });
      },

      //更改每页条数
      handleSizeChange(val) {
        this.page.pageSize = val;
        this.getGoodsInfo();
      },

      handleCurrentChange(val) {
        this.page.pageNo = val;
        this.getGoodsInfo();
      },

      //获取订单信息
      async getGoodsInfo() {
        let that = this,
          params = {
            billNo: that.billNo
          };
        let res = await OrderApi.getGoodsInfo(params);
        console.log(res);
        if (res.code == 0 && res.succ == 1) {
          that.deliveryDetail = res.result;
        }
        that.$vs.loading.close();
      },

      //获取订单列表
      async getGoodsList() {
        let that = this,
          params = {
            data: that.billNo,
            pageNo: that.page.pageNo,
            pageSize: that.page.pageSize,
          };
        let res = await OrderApi.sendGoodsList(params);
        console.log(res);
        if (res.code == 0 && res.succ == 1) {
          that.deliveryList = res.result.list;
          this.page.totalCount = res.result.totalCount;
        }
        that.$vs.loading.close();
      }
    },
    watch: {},
  };
</script>

<style lang="scss" scoped>
  @import '../../order/order.scss';
  @import '@/modules/commodity-sys/commodity.scss';
</style>
<style lang="scss">
  .deli-head {

    background: #fff;
    margin-top: 10px;
  }

  .el-image-viewer__wrapper {
    z-index: 10000 !important;
  }

  .dialog-box .el-drawer__header {
    margin-bottom: 10px !important;

    span {
      font-size: 16px;
      font-weight: 500;
      color: #3f90ff;
    }
  }
</style>
